import { MallErrorFragment } from "@saleor/fragments/types/MallErrorFragment";
import { commonMessages } from "@saleor/intl";
import { MallErrorCode } from "@saleor/types/globalTypes";
import { IntlShape } from "react-intl";

import commonErrorMessages from "./common";

function getMallErrorMessage(
  err: Omit<MallErrorFragment, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case MallErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case MallErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      case MallErrorCode.UNIQUE:
        return "Mall name is already exist";
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getMallErrorMessage;
